module.exports = __webpack_public_path__ + "static/media/super_pack_en_chien_ete.c7854153.png";